import { OptimumCircles } from './styles';

// * This component functions as an animated background of optimum Circles
// * The optimum Circles are pseudo elements made out of css gradients
// * Each circle is running a keyframe animation where we rotate and scale the circles. The animations run on seperate durations and delays

const Background = () => {
  return <OptimumCircles />;
};

export default Background;
